/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it handle emoji correctly?`)
};

const es_rv_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Maneja correctamente los emoji?`)
};

const de_rv_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden Emojis korrekt behandelt?`)
};

const nl_rv_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worden emoji's correct verwerkt?`)
};

const fr_rv_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère-t-il correctement les emoji ?`)
};

const it_rv_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisce correttamente le emoji?`)
};

const pt_br2_rv_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele lida com emojis corretamente?`)
};

const pt_rv_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lida corretamente com emoji?`)
};

const ja_rv_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絵文字は正しく処理されますか?`)
};

const zh_rv_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它能正确处理表情符号吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_faq1_q", locale)
	if (locale === "en") return en_rv_faq1_q(inputs)
	if (locale === "es") return es_rv_faq1_q(inputs)
	if (locale === "de") return de_rv_faq1_q(inputs)
	if (locale === "nl") return nl_rv_faq1_q(inputs)
	if (locale === "fr") return fr_rv_faq1_q(inputs)
	if (locale === "it") return it_rv_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_rv_faq1_q(inputs)
	if (locale === "pt") return pt_rv_faq1_q(inputs)
	if (locale === "ja") return ja_rv_faq1_q(inputs)
	return zh_rv_faq1_q(inputs)
};